import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

const Text = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
`;

const ErrorText = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph};
    color: ${({ theme }) => theme.colors.Color1_75};
`;

const SubmitButton = styled(ButtonV2)`
    margin-top: 16px;
`;

export { Text, ErrorText, SubmitButton };
